module.exports = __webpack_public_path__ + "img/20200410140343898.f51ed10c.png";